// tags require useScrollToTag hook to be present to work
export enum ScrollTag {
  // Clinic
  IsUserDeletionEnabled = 'is_user_deletion_enabled',
  IsPatientTransferEnabled = 'is_patient_transfer_enabled',
  IsCheckInPhotoCaptureEnabled = 'is_check_in_photo_capture_enabled',
  CallStartSoundClinic = 'call_start_sound_clinic',

  // Profile
  PersonalInfo = 'personal_info',
  ProfessionalInfo = 'professional_info',

  // Account
  SignInAndSecurity = 'sign_in_and_security',
  DeleteAccount = 'delete_account',

  // Subscription
  PlansAndPayment = 'plans_and_payment',
  SeatsAndPermissions = 'seats_and_permissions',

  // BAA
  BusinessAssociateAgreement = 'business_associate_agreement',
  GenerateAnAgreement = 'generate_an_agreement',

  // Preferences
  CheckInNotifications = 'check_in_notifications',
  ChatMessageNotifications = 'chat_message_notifications',
  CallStartSound = 'call_start_sound',
  SelfPreviewVideo = 'self_preview_video',
  Localization = 'localization',

  // Waiting Room
  RoomWebAddress = 'room_web_address',
  CheckIn = 'check_in',

  // Apps

  // Branding
  PlatformCustomization = 'platform_customization',

  // Custom Waiting Room Form
  CWRToggle = 'cwr_toggle',
  CWRReception = 'cwr_reception',
  CWRPatientInstructions = 'cwr_patient_instructions',
  CWRProfessionalInformation = 'cwr_professional_information',
  CWRAdditionalInformation0 = 'cwr_additional_information_0',
  CWRAdditionalInformation1 = 'cwr_additional_information_1',
  CWRAdditionalInformation2 = 'cwr_additional_information_2',
  CWRAdditionalInformation3 = 'cwr_additional_information_3',
  CWRAdditionalInformation4 = 'cwr_additional_information_4',
  CWRAdditionalInformation5 = 'cwr_additional_information_5',
}

export const SCROLL_TAG_KEY = 'scrollTo';
